module.exports = __webpack_public_path__ + "img/SQL Sync.07eae625.svg";